"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
class DumpBase extends stdGrid_1.default {
    // private view: webix.ui.datatable;
    constructor(app, name) {
        super(app, name, {
            moduleName: "dbBackup",
            datatableName: "dbBackupdatatable",
            columns: [
                // {id : "chrono", header : _("N°"), width : 40, css : {"text-align" : "right"}},
                { id: "filename", header: (0, globals_1._)("Nom du fichier"), width: 250, sort: "text" },
                { id: "filedate", header: (0, globals_1._)("Date - heure"), width: 180, format: function (value) {
                        return webix.i18n.fullDateFormatStr(value);
                    } },
                {
                    id: "filesize", header: (0, globals_1._)("Taille"), width: 120, css: { "text-align": "right" }, sort: "int",
                    format: function (value) {
                        return webix.i18n.intFormat(value);
                    }
                }
            ],
            title: (0, globals_1._)("Liste des sauvegardes"),
            boutons: [
                {
                    id: "sauvegardeButton", "view": "button", width: 250,
                    type: "icon", icon: "mdi mdi-content-save-all-outline", "value": (0, globals_1._)("Sauvegarder"),
                    click: () => this.sauvegarder()
                }, {
                    id: "restaurerButton", "view": "button", tooltip: (0, globals_1._)("Restaurer"), width: 250,
                    type: "icon", icon: "mdi mdi-history", "value": (0, globals_1._)("Restaurer"),
                    click: () => this.restaurer()
                }
            ],
            resizeColumn: true,
            urlData: globals_1.phpPath + "DumpBase.php?tname=DumpBase&option=list"
        });
    }
    sauvegarder() {
        let me = this;
        this.currentGrid.showOverlay((0, globals_1._)("Sauvegarde en cours ..."));
        this.currentGrid.disable();
        let req = globals_1.phpPath + "DumpBase.php?option=dump";
        globals_1.lv2.trace(webix.message(req));
        // @ts-ignore
        webix.ajax().get(req).then(function (data) {
            // webix.alert(_("Sauvegarde")).then(function() {
            me.currentGrid.enable();
            me.currentGrid.hideOverlay();
            me.currentGrid.clearAll();
            me.reload();
        });
    }
    restaurer() {
        let me = this;
        let item = this.currentGrid.getSelectedItem();
        if (item) {
            let dt = webix.i18n.fullDateFormatStr(item.filedate);
            webix.confirm((0, globals_1._)("Veuillez confirmer la restauration de la base au : ") + dt)
                .then(function () {
                me.currentGrid.showOverlay((0, globals_1._)("Restauration en cours du fichier : ") + item.filename);
                me.currentGrid.disable();
                let req = globals_1.phpPath + "DumpBase.php?option=restore&fileName=" + item.filename;
                // @ts-ignore
                webix.ajax().get(req).then(function (data) {
                    me.currentGrid.enable();
                    me.currentGrid.hideOverlay();
                    me.currentGrid.clearAll();
                    me.reload();
                });
            });
        }
        else {
            webix.alert((0, globals_1._)("Aucune ligne n'est sélectionnée"));
        }
    }
    init() {
        this.currentGrid = $$(this.datatableName);
        let me = this;
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "sauvegardeButton":
                    me.sauvegarder();
                    break;
                case "restaurerButton":
                    me.restaurer();
                    break;
            }
        });
    }
    ready() {
        let me = this.currentGrid;
        me.attachEvent("onAfterLoad", function () {
            me.sort("filename", "desc");
        });
    }
}
exports.default = DumpBase;
